'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var V2Controller = function V2Controller($scope, User, AuthenticationService, $rootScope, $cookieStore, V2Service, CONST) {
  _classCallCheck(this, V2Controller);

  $rootScope.stopTokenRefresh = true;
  this.user = User.getUser();
  this.name = 'v2';
  var cfDomain = '.codefocus.com.au';
  var cfDomainIndex = window.location.hostname.indexOf(cfDomain) || window.location.hostname.indexOf('10.0.1.1');
  $rootScope.globals = $cookieStore.get('globals');

  this.userRoleId = 0;
  if ($rootScope.globals.currentUser && $rootScope.globals.currentUser.roleId) {
    $scope.vm.userRoleId = $rootScope.globals.currentUser.roleId ? $rootScope.globals.currentUser.roleId : this.user.roleId;
  }

  AuthenticationService.SetCredentials($rootScope.globals.currentUser.codingOperationsTeam, this.user.email, this.user.name, this.user.specialty, this.user.role, this.user.worklist, this.user.id, this.user.token, $scope.vm.userRoleId, $rootScope.globals.currentUser.redirectRoute, $rootScope.globals.currentUser.activeDirectoryToken, $rootScope.globals.currentUser.initialLogin, this.user.campus);

  if (window.location.hostname.indexOf('localhost') > -1) {
    if ($scope.vm.userRoleId) {
      window.location = 'http://localhost:4200/' + V2CONTEXT + '?token=' + $rootScope.globals.currentUser.token + '&roleId=' + $scope.vm.userRoleId + '&redirectRoute=' + $rootScope.globals.currentUser.redirectRoute;
    }
  } else if (cfDomainIndex) {
    V2Service.redirectToV2($scope.vm.userRoleId);
  }
};

exports.default = V2Controller;


// WEBPACK FOOTER //
// ./client/app/components/v2/v2.controller.js